const MgDl = () => (
    <section id="mg-dl">
       <div className="container-fluid py-3 text-center gg-bg-gradient-v text-white">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-9 col-11">
                    <p>Then I pricked my finger and checked my blood sugar.</p>
                    <p className="fw-bold">98 mg/dL.</p>
                    <p>Perfectly normal.<br/>Not a fluke. Not a cheat day.</p>
                    <h3 className="my-3 fw-bold">This is my life now.</h3>   
                    <p>Not one ruled by food restrictions, guilt, or fear, but by freedom.</p>         
                </div>
            </div>
        </div>
    </section>
);

export default MgDl;